













import Vue from "vue";
import axios from "axios";
import config from "@/config/constants";
import MeetingRoom from "@/components/Session/MeetingRoom.vue";
import { parseAppointmentTime } from "@/utils/appointmentTimezone";
import { isEmbedded } from "@/utils/embed/embed";

export default Vue.extend({
  name: "Session",
  components: {
    MeetingRoom,
  },
  data() {
    return {
      loading: true,
      booking: null,
      serviceProvider: null
    };
  },

  mounted() {
    let self = this;
    this.getAppointment();

  },
  methods: {
    getAppointment() {
      if (this.$route.params.type === 'dmh') {
        this.getDmhAppointment();
      } else if (
        this.$route.params.type === 'tmh'
      ) {
        // TMH container manages it's own data fetching and loading state
        this.loading = false;
      }
    },
    async getDmhAppointment() {
      try {
        // The store is only populated when the side bar has been opened, so on a
        // direct link (a partner embedding /session/dmh/:id, a reminder email) it is
        // still the default `false` — fetch the appointment instead of giving up.
        //
        // Embedded, skip the store entirely and always fetch fresh: vuex-persistedstate
        // persists `appointments` per origin, not per session, so a shared/QA browser
        // can carry a stale or another user's list into a brand new embed. Trusting it
        // here reported "couldn't find this appointment" for a booking that a fresh
        // fetch would have found.
        const stored = this.$store.state.appointments;
        const appointments = !isEmbedded() && Array.isArray(stored) && stored.length
          ? stored
          : await this.fetchAppointments();

        this.booking = appointments.filter((appointment) => {
          return appointment.appointmentId === this.$route.params.id
        })[0] || null;
      } catch (err) {
        console.error(err);
        this.booking = null;
      } finally {
        this.loading = false;
      }
    },
    async fetchAppointments() {
      const res = await (this as any).api({ path: "api/u/dmh/get-all-appointments" });
      const rawAppointments = res?.appointments ?? [];
      // Mirrors SideBar's mapping so MeetingRoom gets the same shape either way.
      const appointments = rawAppointments.map((booking) => {
        const startTime = parseAppointmentTime(booking.startTime);
        const endTime = parseAppointmentTime(booking.endTime);
        return {
          ...booking,
          startDublinMs: startTime ? startTime.valueOf() : 0,
          endDublinMs: endTime ? endTime.valueOf() : 0,
        };
      });
      this.$store.commit("setAppointments", appointments);
      return appointments;
    },
  },
  computed: {

  },
  watch: {
    $route() {
      this.getAppointment();
    }
  }
});
